// case insensitive include substring method
function includesSubstring(haystack, needle) {
  return haystack.toLowerCase().indexOf(needle.toLowerCase()) !== -1;
}

export default includesSubstring;
